DeliveryEstimates = window.DeliveryEstimates ?= {}

DealEventPipe = require '../../../deal/frontend/event_pipe'

DeliveryEstimates.View = Backbone.View.extend

  el: "#purchase-cluster .delivery-estimates-container"

  initialize: ({deliveryEstimates}) ->
    @deliveryEstimates = deliveryEstimates

    DealEventPipe.on "priceUpdate", (priceData) =>
      @updateDeliveryEstimatesMessage priceData

  updateDeliveryEstimatesMessage: ({uuid}) ->
    if estimates = @deliveryEstimates?[uuid]
      @$el.removeClass('hide')
      @$el.html "<span class='icon-truck'></span>#{estimates}"
    else
      @$el.addClass('hide')


module.exports = DeliveryEstimates.View
